export function toNumber(val, fallback = 0) {
  if (typeof val === 'number') return Number.isFinite(val) ? val : fallback;
  const s = String(val ?? '').replace(/[^0-9.-]/g, '');
  const n = parseFloat(s);
  return Number.isFinite(n) ? n : fallback;
}

export function round2(n) {
  return Math.round((toNumber(n, 0) + Number.EPSILON) * 100) / 100;
}

export function formatMoney(amount, { currency = 'USD', locale = 'en-US' } = {}) {
  const n = round2(toNumber(amount, 0));
  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      maximumFractionDigits: 2,
    }).format(n);
  } catch {
    return currency === 'USD' ? `$${n.toFixed(2)}` : `${currency} ${n.toFixed(2)}`;
  }
}

